import { LocalizedRoute } from '../../routes/localizedRoutes'
import BasicInfo from '../BasicInfo'
import ChangePassword from '../ChangePassword'
import { useStyles } from './styles/RenderPage.styles'

const RenderPage = () => {
  const classes = useStyles()
  return (
    <div className={classes.pageWidth}>
      <LocalizedRoute path="/settings/basic-info">
        <BasicInfo />
      </LocalizedRoute>
      <LocalizedRoute path="/settings/change-password">
        <ChangePassword />
      </LocalizedRoute>
    </div>
  )
}
export default RenderPage
